<footer>
  <div class="contact-info">
    <p>
      <strong>Contact:</strong>
      <a href="mailto:cassettiquetteband@gmail.com">cassettiquetteband@gmail.com</a>
    </p>
  </div>
  <p class="copyright">&copy; {new Date().getFullYear()} Cassettiquette. All rights reserved.</p>
</footer>

<style>
  footer {
    padding: 1rem;
    text-align: center;
    margin-top: 2rem;
    border-top: 2px solid var(--light-purple);
  }
  a {
    color: var(--light-purple);
    text-decoration: none;
  }
  .copyright {
    color: var(--primary-purple);
    margin-top: 1rem;
    font-size: 0.9rem;
  }

  @media (min-width: 768px) {
    footer {
      padding: 2rem;
      margin-top: 4rem;
    }
  }
</style>
